import $ from 'jquery';
import {setHeight} from '../filter';

export default class {
	constructor(options) {
		const defaults = {
			el: '.js-filter-mobile',

			dom: {
				body: '.js-body',
				list: '.js-filter-mobile-list',
				nav: '.js-filter-mobile-nav',
				items: '.js-filter-mobile-items',
				brands: '.js-filter-brands',
				content: '.js-filter-mobile-items-wrap',
				clean: '.js-filter-mobile-clean',

				checkbox: {
					input: '.js-checkbox-input'
				}
			},

			classes: {
				filter: {
					state: {
						open: 'filter-mobile__list_state_open',
						opened: 'filter-mobile__list_state_opened',
						active: 'filter-mobile__list_state_active'
					}
				}
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		return this;
	}

	getDom() {
		this.$body = this.$el.closest(this.options.dom.body);
		this.$list = this.$el.find(this.options.dom.list);
		this.$nav = this.$el.find(this.options.dom.nav);
		this.$items = this.$el.find(this.options.dom.items);
		this.$brands = this.$el.find(this.options.dom.brands);
		this.$content = this.$el.find(this.options.dom.content);
		this.$clean = this.$el.find(this.options.dom.clean);
		this.$input = this.$el.find(this.options.dom.checkbox.input);
		this.open = this.options.classes.filter.state.open;
		this.opened = this.options.classes.filter.state.opened;
		this.active = this.options.classes.filter.state.active;
		return this;
	}

	onClick(e) {
		const $target = $(e.target);
		const $list = $target.closest(this.$list);
		const $items = $list.find(this.$items);
		const $content = $list.find(this.$content);
		if (!$list.hasClass(this.opened)) {
			$list.addClass(this.opened);
			setHeight($items, $content);
		}
		else {
			$list.removeClass(this.opened);
			$items.css('height', 0);
		}
	}

	onShow(e) {
		const $target = $(e.target);
		const $list = $target.closest(this.$list);
		const $input = $list.find(this.$input).is(':checked');
		if ($input) {
			$list.addClass(this.active);
		}
		else {
			$list.removeClass(this.active);
		}
	}

	onLoad() {
		const self = this;

		self.$list.each(function () {
			const $list = $(this);
			const $input = $list.find(self.$input).is(':checked');
			if ($input) {
				$(this).addClass(self.active);
			}
			else {
				$(this).removeClass(self.active);
			}
		});
	}

	// fixBrands() {
	// 	this.$body.addClass('noscroll');
	// }

	// freeBrands() {
	// 	this.$body.removeClass('noscroll');
	// }

	reset(e) {
		const $target = $(e.target);
		const $list = $target.closest(this.$list);
		const $input = $list.find(this.$input);
		$input.attr('checked', false);
		$list.removeClass(this.active);
	}

	render() {
		if (this.$el.length) {
			this.getDom();
			this.$nav.on('click', this.onClick.bind(this));
			this.$clean.on('click', this.reset.bind(this));
			// this.$brands.on('mouseenter', () => this.fixBrands());
			// this.$brands.on('mouseleave', () => this.freeBrands());
			this.$input.on('click', this.onShow.bind(this));
			$(window).on('load', this.onLoad.bind(this));

		}
		return this;
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/filter/filter-mobile/filter-mobile.js
 **/